<template>
  <select :value="modelValue" aria-label="Year" @change="onChange">
    <option v-for="option in options" :key="option.value" :value="option.value">{{ option.label }}</option>
  </select>
</template>

<script>
import { periodOptions } from "@/_helpers/period";

// Year filter used on the reports. The value is a year offset (see _helpers/period.js).
// When buildingId is given, the list starts at that building's registration year.
// Class, style, id and name set on the tag are applied to the <select>.
export default {
  name: "PeriodSelect",
  props: {
    modelValue: { type: [Number, String], default: 1 },
    buildingId: { type: [Number, String], default: null },
  },
  emits: ["update:modelValue"],
  computed: {
    currentBuilding() {
      return this.$store.state.building.currentBuilding || {};
    },
    registrationYear() {
      const id = Number(this.buildingId);
      const building = this.currentBuilding;
      // only trust the stored building if it is the one this page is about
      if (id > 0 && Number(building.id) !== id) return 0;
      return Number(building.registrationYear) || 0;
    },
    options() {
      return periodOptions(new Date(), this.registrationYear);
    },
  },
  watch: {
    buildingId: { immediate: true, handler: "ensureBuilding" },
  },
  methods: {
    ensureBuilding() {
      const id = Number(this.buildingId);
      if (id > 0 && Number(this.currentBuilding.id) !== id) {
        this.$store.dispatch("building/fetchBuilding", id);
      }
    },
    onChange(event) {
      this.$emit("update:modelValue", Number(event.target.value));
    },
  },
};
</script>
